/*
 * SERAF — JS custom (chargé en defer via seraf-head-extras.liquid)
 * Refonte Seraf.ch — juin 2026
 * Règle : non destructif, scoping strict aux composants seraf-*.
 */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  /* ----------------------------------------------------------------------
   * C1 — Hero slider par univers (crossfade + onglets + autoplay lent)
   * -------------------------------------------------------------------- */
  function initHeroSlider(root) {
    if (!root || root.dataset.heroInit === 'true') return;

    var slider = root.querySelector('[data-hero-slider]');
    if (!slider) return;

    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-hero-slide]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-hero-tab]'));
    var primaryCta = root.querySelector('[data-hero-primary]');
    if (slides.length === 0) return;

    root.dataset.heroInit = 'true';

    var current = 0;
    var autoplayMs = (parseInt(root.dataset.autoplay, 10) || 0) * 1000;
    var timer = null;

    function goTo(index) {
      index = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      tabs.forEach(function (tab, i) {
        var active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      var onPromo = slides[index] && slides[index].dataset.heroPromo === 'true';
      root.classList.toggle('seraf-hero--on-promo-slide', onPromo);
      if (primaryCta && tabs[index] && tabs[index].dataset.heroLink) {
        primaryCta.setAttribute('href', tabs[index].dataset.heroLink);
        if (tabs[index].classList.contains('seraf-hero__quick-pill--promo')) {
          var promoLabel = root.querySelector('.seraf-hero__promo-cta');
          primaryCta.textContent = promoLabel
            ? promoLabel.textContent.trim()
            : tabs[index].textContent.trim();
        }
      }
      current = index;
    }

    function next() {
      goTo(current + 1);
    }

    function startAutoplay() {
      stopAutoplay();
      if (autoplayMs > 0 && slides.length > 1 && !prefersReducedMotion) {
        timer = window.setInterval(next, autoplayMs);
      }
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        goTo(i);
        startAutoplay(); // relance le minuteur après une interaction
      });
    });

    // Pause au survol / focus clavier
    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);

    // Pause quand l'onglet navigateur n'est pas visible (économise le GPU mobile)
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    goTo(0);
    startAutoplay();
  }

  function initAllHeroSliders(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.slice
      .call(ctx.querySelectorAll('[data-hero-root]'))
      .forEach(initHeroSlider);
    // si scope est lui-même un hero root
    if (scope && scope.matches && scope.matches('[data-hero-root]')) {
      initHeroSlider(scope);
    }
  }

  /* ----------------------------------------------------------------------
   * Reveal au scroll (IntersectionObserver, one-shot) — [data-seraf-reveal]
   * Ajoute .is-revealed une seule fois. Seuil via data-reveal-threshold.
   * -------------------------------------------------------------------- */
  function initReveal(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    var els = Array.prototype.slice.call(ctx.querySelectorAll('[data-seraf-reveal]'));
    if (scope && scope.matches && scope.matches('[data-seraf-reveal]')) {
      els.push(scope);
    }
    if (els.length === 0) return;

    if (!('IntersectionObserver' in window) || prefersReducedMotion) {
      els.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    els.forEach(function (el) {
      if (el.dataset.revealInit === 'true') return;
      el.dataset.revealInit = 'true';
      var threshold = parseFloat(el.dataset.revealThreshold) || 0.15;
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: threshold }
      );
      observer.observe(el);
    });
  }

  /* ----------------------------------------------------------------------
   * #25 — Badges pourcentage colorés par palier de remise
   * -10/−20 bleu · -25/−30 vert · -35/−40 orange · -45+ jaune
   * -------------------------------------------------------------------- */
  function colorDiscountBadges(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    var nodes = ctx.querySelectorAll('.badge');
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.dataset.serafBadge === 'true') return;
      var m = (el.textContent || '').match(/[-–−]\s*(\d+)\s*%/);
      if (!m) return;
      var pct = parseInt(m[1], 10);
      var tier = pct < 25 ? 1 : pct < 35 ? 2 : pct < 45 ? 3 : 4;
      el.classList.add('seraf-badge-disc', 'seraf-badge-disc--t' + tier);
      el.dataset.serafBadge = 'true';
    });
  }

  // Re-colore après mise à jour AJAX de la grille produits (filtres PLP)
  function observeDiscountBadges() {
    if (!('MutationObserver' in window) || window.__serafBadgeObs) return;
    var grid = document.querySelector('.main-collection__products, [data-ref="main-collection-products"]');
    if (!grid) return;
    window.__serafBadgeObs = true;
    var timer = null;
    var mo = new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        colorDiscountBadges(grid);
      }, 120);
    });
    mo.observe(grid, { childList: true, subtree: true });
  }

  /* ----------------------------------------------------------------------
   * Scroll infini PLP — "voir tous les produits sur une seule page"
   * Remplace la pagination ; filtres/tri natifs en AJAX → ré-init via
   * l'événement 'filters:updated' (le bloc produits est remplacé).
   * -------------------------------------------------------------------- */
  function serafInfiniteScroll() {
    var container = document.querySelector('[data-ref="main-collection-products"]');
    if (!container || container.dataset.serafInf === '1') return;
    var grid = container.querySelector('[data-ref="main-collection-grid"]');
    var pag = container.querySelector('.pagination-wrapper');
    if (!grid || !pag) return; // une seule page : rien à faire

    var nums = Array.prototype.slice
      .call(pag.querySelectorAll('.pagination__item'))
      .map(function (el) { return parseInt((el.textContent || '').trim(), 10); })
      .filter(function (n) { return !isNaN(n); });
    var lastPage = nums.length ? Math.max.apply(null, nums) : 1;
    var nextPage =
      parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10) + 1;
    if (nextPage > lastPage) return; // déjà sur la dernière page

    container.dataset.serafInf = '1';
    pag.style.display = 'none';

    var spinner = document.createElement('div');
    spinner.className = 'seraf-infinite-spinner';
    spinner.hidden = true;
    var sentinel = document.createElement('div');
    sentinel.className = 'seraf-infinite-sentinel';
    container.appendChild(spinner);
    container.appendChild(sentinel);

    var loading = false;
    var done = false;
    var observer = null;

    function loadNext() {
      if (loading || done || nextPage > lastPage) return;
      loading = true;
      spinner.hidden = false;
      var u = new URL(window.location.href);
      u.searchParams.set('page', String(nextPage));
      fetch(u.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (txt) {
          var doc = new DOMParser().parseFromString(txt, 'text/html');
          var newGrid = doc.querySelector('[data-ref="main-collection-grid"]');
          if (newGrid) {
            grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
            if (typeof colorDiscountBadges === 'function') colorDiscountBadges(grid);
            var age = new URLSearchParams(window.location.search).get('age') || '';
            if (age) serafApplyIzipiziFilter(age);
          }
          nextPage++;
          loading = false;
          spinner.hidden = true;
          if (nextPage > lastPage) {
            done = true;
            if (observer) observer.disconnect();
            sentinel.remove();
            spinner.remove();
          }
        })
        .catch(function () {
          loading = false;
          spinner.hidden = true;
        });
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) loadNext();
          }
        },
        { rootMargin: '800px 0px' }
      );
      observer.observe(sentinel);
    } else {
      loadNext();
    }
  }

  /* ----------------------------------------------------------------------
   * Izipizi — filtre tranches sur la collection parent (sans navigation)
   * -------------------------------------------------------------------- */
  var serafIzipiziGridObs = null;

  function serafAgeFromHref(href) {
    if (!href) return '';
    var path = href.split('?')[0];
    if (path.slice(-21) === '/les-lunettes-izipizi' || path.slice(-22) === '/les-lunettes-izipizi/') return '';
    if (path.indexOf('-kids-plus') !== -1) return 'kids+';
    if (path.indexOf('-baby') !== -1) return 'baby';
    if (path.indexOf('-junior') !== -1) return 'junior';
    if (path.indexOf('-kids') !== -1) return 'kids';
    return '';
  }

  function serafGetCardAge(card) {
    var tagged = card.getAttribute('data-seraf-izipizi-age');
    if (tagged) return tagged;
    var url = card.getAttribute('data-product-url') || '';
    return serafAgeFromHref(url);
  }

  function serafGetPillAge(pill) {
    if (pill.hasAttribute('data-seraf-izipizi-pill')) {
      return pill.getAttribute('data-seraf-izipizi-pill') || '';
    }
    if (pill.tagName === 'A') {
      return serafAgeFromHref(pill.getAttribute('href') || '');
    }
    return '';
  }

  function serafSetIzipiziPill(ageKey) {
    var nav = document.querySelector('[data-seraf-izipizi-nav], .seraf-izipizi-nav');
    if (!nav) return;
    var pills = nav.querySelectorAll('[data-seraf-izipizi-pill], .seraf-izipizi-nav__pills a, .seraf-izipizi-nav__pills button');
    for (var i = 0; i < pills.length; i++) {
      var pill = pills[i];
      var pillAge = serafGetPillAge(pill);
      var isActive = pillAge === ageKey;
      pill.classList.toggle('seraf-izipizi-nav__pill--active', isActive);
      pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      if (isActive) pill.setAttribute('aria-current', 'true');
      else pill.removeAttribute('aria-current');
    }
  }

  function serafApplyIzipiziFilter(ageKey) {
    var grid = document.querySelector('[data-ref="main-collection-grid"]');
    if (!grid) return;

    var visible = 0;
    var cards = grid.querySelectorAll('product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var cardAge = serafGetCardAge(card);
      var show = !ageKey || (cardAge !== '' && cardAge === ageKey);
      card.classList.toggle('seraf-izipizi-hidden', !show);
      if (show) visible++;
    }

    var emptyEl = document.querySelector('[data-seraf-izipizi-empty]');
    if (emptyEl) emptyEl.hidden = visible > 0 || !ageKey;

    var resultEl = document.querySelector('[data-seraf-izipizi-result]');
    if (resultEl) {
      if (ageKey && visible > 0) {
        resultEl.textContent = visible + (visible > 1 ? ' modèles affichés' : ' modèle affiché');
        resultEl.hidden = false;
      } else {
        resultEl.hidden = true;
        resultEl.textContent = '';
      }
    }

    serafSetIzipiziPill(ageKey);

    var activePill = document.querySelector('.seraf-izipizi-nav__pill--active');
    if (activePill && typeof activePill.scrollIntoView === 'function') {
      activePill.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    var url = new URL(window.location.href);
    if (ageKey) url.searchParams.set('age', ageKey);
    else url.searchParams.delete('age');
    url.searchParams.delete('page');
    history.replaceState({}, '', url);
  }

  function serafOnIzipiziNavClick(event) {
    var pill = event.target.closest('[data-seraf-izipizi-pill], .seraf-izipizi-nav__pills a, .seraf-izipizi-nav__pills button');
    if (!pill || !pill.closest('.seraf-izipizi-nav__pills')) return;
    event.preventDefault();
    serafApplyIzipiziFilter(serafGetPillAge(pill));
  }

  function serafWatchIzipiziGrid() {
    var grid = document.querySelector('[data-ref="main-collection-grid"]');
    if (!grid || serafIzipiziGridObs || !('MutationObserver' in window)) return;
    serafIzipiziGridObs = new MutationObserver(function () {
      var ageKey = new URLSearchParams(window.location.search).get('age') || '';
      if (ageKey) serafApplyIzipiziFilter(ageKey);
    });
    serafIzipiziGridObs.observe(grid, { childList: true });
  }

  function serafIzipiziFilterInit(scope) {
    var root = scope && scope.querySelector ? scope : document;
    var nav = root.querySelector('[data-seraf-izipizi-nav], .seraf-izipizi-nav');
    if (!nav || nav.dataset.serafIzipiziReady === '1') return;
    if (!document.querySelector('[data-ref="main-collection-grid"]')) return;

    nav.dataset.serafIzipiziReady = '1';
    nav.addEventListener('click', serafOnIzipiziNavClick);
    serafWatchIzipiziGrid();

    var initialAge = new URLSearchParams(window.location.search).get('age') || '';
    if (initialAge) serafApplyIzipiziFilter(initialAge);
    else serafSetIzipiziPill('');
  }

  window.serafApplyIzipiziFilter = serafApplyIzipiziFilter;

  /* ----------------------------------------------------------------------
   * Newsletter homepage — retour visuel après inscription (return_to + scroll)
   * -------------------------------------------------------------------- */
  function initSerafNewsletterForms(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    var forms = Array.prototype.slice.call(ctx.querySelectorAll('.seraf-newsletter__form'));
    if (scope && scope.matches && scope.matches('.seraf-newsletter__form')) {
      forms.push(scope);
    }

    forms.forEach(function (form) {
      if (form.dataset.serafNewsletterReady === '1') return;
      form.dataset.serafNewsletterReady = '1';

      var submitBtn = form.querySelector('[data-seraf-newsletter-submit]');
      var feedback = form.querySelector('[data-seraf-newsletter-feedback]');
      var successEl = form.querySelector('[data-seraf-newsletter-success]');
      var anchor = document.getElementById('offre-bienvenue');

      function scrollToNewsletter() {
        if (!anchor || typeof anchor.scrollIntoView !== 'function') return;
        anchor.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'center' });
      }

      if (successEl || (feedback && feedback.textContent.trim())) {
        scrollToNewsletter();
        var focusTarget = successEl || feedback.querySelector('[role="alert"], [role="status"]');
        if (focusTarget && typeof focusTarget.focus === 'function') {
          focusTarget.focus({ preventScroll: true });
        }
      } else if (window.location.hash === '#offre-bienvenue') {
        scrollToNewsletter();
      }

      form.addEventListener('submit', function () {
        if (!submitBtn) return;
        submitBtn.classList.add('is-loading');
        submitBtn.setAttribute('aria-busy', 'true');
        submitBtn.disabled = true;
      });
    });
  }

  /* ----------------------------------------------------------------------
   * Liens obsolètes — barre d'annonce et contenus SEO (juillet 2026)
   * -------------------------------------------------------------------- */
  function serafFixBrokenLinks(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    /* La page /pages/petit-bateau-geneve est en ligne : plus de redirection (30/09/2026). */
    void ctx;
  }

  function serafExpireBtsPromo() {
    if (Date.now() < Date.parse('2026-08-24T00:00:00+02:00')) return;
    document.querySelectorAll('.seraf-bts-until-20260823, .announcement-bar a').forEach(function (el) {
      var match = el.classList.contains('seraf-bts-until-20260823') || /Back to School|3 articles achetés/i.test(el.textContent || '');
      if (!match) return;
      var slide = el.closest('.splide__slide');
      if (slide) {
        slide.remove();
        return;
      }
      var block = el.closest('[class*="announcement"]');
      if (block && block !== document.querySelector('.announcement-bar')) block.remove();
    });
  }

  function initAll(scope) {
    initAllHeroSliders(scope);
    initReveal(scope);
    colorDiscountBadges(scope);
    serafInfiniteScroll();
    serafIzipiziFilterInit(scope);
    initSerafNewsletterForms(scope);
    serafFixBrokenLinks(scope);
    serafExpireBtsPromo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
      observeDiscountBadges();
    });
  } else {
    initAll(document);
    observeDiscountBadges();
  }

  // Support éditeur de thème Shopify (rechargement de section)
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  // PLP : le bloc produits est remplacé après filtre/tri AJAX → relancer le scroll infini
  document.addEventListener('filters:updated', function () {
    serafInfiniteScroll();
    var age = new URLSearchParams(window.location.search).get('age') || '';
    if (age) serafApplyIzipiziFilter(age);
  });
})();
